export enum OnboardingStep {
  GDPR = 'gdpr',
  PERMISSIONS = 'mobileAppPermissions',
  PROFILE = 'profileInformation',
  LOCATION = 'parcelPickupLocation',
  PAYMENT = 'payment',
  DONE = 'done',
}

export function isOnboardingStep(value: unknown): value is OnboardingStep {
  if (typeof value !== 'string') {
    return false;
  }
  return Object.values(OnboardingStep as Record<string, string>).includes(value);
}

export const OnboardingStepOrder = {
  [OnboardingStep.GDPR] : 1,
  [OnboardingStep.PERMISSIONS] : 2,
  [OnboardingStep.PROFILE] : 3,
  [OnboardingStep.LOCATION] : 4,
  [OnboardingStep.PAYMENT] : 5,
  [OnboardingStep.DONE] : 6,
} as const;
